module.exports = __webpack_public_path__ + "img/avatar6.e4b19ab6.png";